/**
 * Mainbeauty — drawer menu mobile: .hdr__burger mở #pi-nav, desktop thì bất động.
 */
function initNavDrawer() {
  const toggle = document.querySelector("[data-pi-nav-toggle]");
  const nav = document.getElementById("pi-nav");
  const backdrop = document.querySelector(".hdr__backdrop[data-pi-nav-close]");
  if (!toggle || !nav) return;

  const setOpen = (open) => {
    nav.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.classList.toggle("pi-nav-open", open);
    // Dùng class chứ không phải [hidden]: display:none sẽ giết fade lúc đóng.
    if (backdrop) backdrop.classList.toggle("is-open", open);
  };

  const isOpen = () => nav.classList.contains("is-open");

  toggle.addEventListener("click", () => setOpen(!isOpen()));

  // Đóng khi: bấm backdrop/nút ✕, bấm một link trong drawer, hoặc Escape.
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-pi-nav-close]")) setOpen(false);
  });
  nav.addEventListener("click", (e) => {
    if (e.target.closest("a")) setOpen(false);
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen()) setOpen(false);
  });

  // Màn hình nới rộng qua breakpoint desktop thì reset trạng thái — phải khớp $screen-xl-min, mốc
  // menu 8 mục chuyển từ drawer sang hàng ngang trong _header.scss.
  const desktop = window.matchMedia("(min-width: 1400px)");
  const syncViewport = () => {
    if (desktop.matches && isOpen()) setOpen(false);
  };
  desktop.addEventListener("change", syncViewport);
}

document.addEventListener("DOMContentLoaded", initNavDrawer);
